/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate, useParams} from 'react-router-dom'

import {Controller, useForm} from 'react-hook-form'
import {joiResolver} from '@hookform/resolvers/joi'
import {AiOutlineInfoCircle} from 'react-icons/ai'
import {FiFileText} from 'react-icons/fi'
import _ from 'lodash'
import Moment from 'moment'
import {
  VmoButton,
  VmoCard,
  VmoCardContent,
  VmoDatePicker,
  VmoForm,
  VmoDropdown,
  VmoFormField,
  VmoFormInput,
  VmoFormCheckbox,
  VmoTooltip,
} from 'vmo-library'

import {
  ADD_SERVICES_COMPO,
  CLEAR_SINGLE_COMPO,
  GET_ALL_COMPO_GROUP,
  GET_SINGLE_COMPO,
  UPDATE_SERVICES_COMPO,
} from 'actions/types'
import {addServicesCompo, getAllServices, getCompoGroup, getsingleCompo, updateServicesCompo} from 'actions/statuspage'
import {getPathWithPrefix, removeDoubleQuotes} from 'utils/helper'
import LockPermissionTooltip from 'components/common/LockPermissionTooltip'
import {serviceComponentsSchema} from 'validation/status-page.schema'
import useUserPermissions from 'hooks/pure/useUserPermission'
import {STATUS_PAGE_PATH} from 'constants/path'
import useApiResponse from 'hooks/impure/useApiResponse'
import {Input} from 'components/common/Form'
import {useUnsavedChanges} from 'hooks/pure/useUnsavedChanges'

export const CreateComponents = ({toggleForm, type}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {id: editId} = useParams()

  const {SingalCompo = {}} = useSelector(state => state.statuspage)
  const {isLoadingData, type: rType, successLabels = []} = useSelector(state => state.apiReducer)
  const [groupValue, setGroupValue] = useState('')
  const [dropDownOptions, setDropDownOptions] = useState([])

  const {setWarningModal} = useUnsavedChanges()

  useApiResponse({
    action: getCompoGroup,
    enabled: true,
    label: GET_ALL_COMPO_GROUP,
    storePath: 'statuspage.CompoGroupList',
    onSuccess: CompoGroupList => {
      const dropDownOptions =
        CompoGroupList?.map(list => ({
          value: list.id,
          key: list.id,
          text: list.name,
        })) || []

      const newDropDownOptions = [
        {
          text: `This Components doesn't belong to any group`,
          value: -1,
        },
        ...dropDownOptions,
      ]
      setDropDownOptions(newDropDownOptions)
    },
  })

  const {
    handleSubmit,
    formState: {errors, isDirty},
    control,
    reset,
    setValue,
  } = useForm({
    mode: 'onTouched',
    shouldFocusError: true,
    reValidateMode: 'onChange',
    submitFocusError: true,
    shouldUnregister: false,
    resolver: joiResolver(serviceComponentsSchema(type)),
    defaultValues: {
      name: '',
      description: '',
      showHistory: false,
      startDate: new Date(),
    },
  })

  const {statusPagePermissions} = useUserPermissions()
  const allowManageServiceRole = statusPagePermissions?.manage_service

  const submitData = data => {
    if (editId) {
      if (type === 'group') {
        dispatch(
          updateServicesCompo(editId, type, {
            groupName: data.name,
            description: data.description,
          })
        )
      }
      if (type === 'service') {
        const payload = {
          ...data,
          startDate: Moment(data.startDate).format('YYYY-MM-DD'),
          ...(groupValue !== -1 && {
            ...(typeof groupValue === 'string' ? {groupName: groupValue} : {groupId: groupValue}),
          }),
        }
        dispatch(updateServicesCompo(editId, type, payload))
      }
    }
    if (!editId) {
      const payload = {
        ...data,
        startDate: Moment(data.startDate).format('YYYY-MM-DD'),
        ...(groupValue !== -1 && {
          ...(typeof groupValue === 'string' ? {groupName: groupValue} : {groupId: groupValue}),
        }),
      }
      dispatch(addServicesCompo(payload))
    }
  }
  useEffect(() => {
    if (isDirty) {
      setWarningModal(true)
    }
    return () => {
      setWarningModal(false)
    }
  }, [isDirty])
  useEffect(() => {
    if (type && editId) {
      dispatch(getsingleCompo(type, editId))
    }
  }, [dispatch, type, editId])

  useEffect(() => {
    if (successLabels.includes(GET_SINGLE_COMPO)) {
      reset(_.pick(SingalCompo, ['name', 'description', 'startDate', 'showHistory']))
      setGroupValue(SingalCompo?.groupId)
      setValue('startDate', new Date(SingalCompo?.startDate))
    }
    if (successLabels.includes(ADD_SERVICES_COMPO)) {
      toggleForm(false)
      setWarningModal(false)
      dispatch(getAllServices())
    }
    if (successLabels.includes(UPDATE_SERVICES_COMPO)) {
      navigate(-1)
      setWarningModal(false)
      dispatch(getAllServices())
    }
  }, [editId, reset, SingalCompo, successLabels, toggleForm, dispatch, navigate, setValue])

  return (
    <>
      <div className="pageHeader px-0 pb-0 mb-4">
        <div className="pageTitle">
          <div className="pageTitleIcon">
            <FiFileText className="bg-svg" />
            <h5>
              {editId ? 'Update' : 'Create'} {type === 'group' ? 'Group' : type === 'service' ? 'Service' : null} {` `}
              Components
            </h5>
          </div>
        </div>
      </div>
      <div className="setBodyContent">
        <VmoForm className="errorLabel" id="user-form">
          <Input
            control={control}
            name="name"
            label="Component Name"
            placeholder="Component name"
            maxLength={30}
            width={10}
            tooltipProps={{
              content: 'Provide the name to the component',
            }}
            required
          />
          <Input
            control={control}
            name="description"
            label="Description"
            placeholder="Description"
            maxLength={200}
            width={10}
            tooltipProps={{
              content: 'Give short description about your component',
            }}
            required
          />
          {!(type === 'group' && editId) && (
            <>
              <VmoFormField width={10} required>
                <div className="info-header">
                  <label>Select Component Group or Create New Group</label>
                  <VmoTooltip content="Specify or create a group for the component" trigger={<AiOutlineInfoCircle />} />
                </div>
                <VmoDropdown
                  options={dropDownOptions}
                  search
                  selection
                  fluid
                  placeholder="Component group"
                  additionLabel="Create new component group: "
                  allowAdditions
                  value={groupValue}
                  onAddItem={(e, {value}) => {
                    setDropDownOptions(prevOptions => [{text: value, value}, ...prevOptions])
                  }}
                  onChange={(e, {value}) => setGroupValue(value)}
                />
              </VmoFormField>
              <VmoCard fluid className="switchBox switchBoxSmall">
                <VmoCardContent>
                  <div className="d-flex">
                    <div>
                      <h5>Display Uptime</h5>
                      <p>Display the historical status of this component on my status page</p>
                    </div>

                    <Controller
                      control={control}
                      name="showHistory"
                      render={({field: {value, onChange}}) => (
                        <VmoFormCheckbox toggle checked={value} onChange={(e, {checked}) => onChange(checked)} />
                      )}
                    />
                  </div>
                </VmoCardContent>
                <VmoCardContent>
                  <VmoFormField required width={8}>
                    <div className="info-header">
                      <label>Start Date</label>
                      <VmoTooltip content="Set start date of the service component" trigger={<AiOutlineInfoCircle />} />
                    </div>
                    <Controller
                      control={control}
                      name="startDate"
                      render={({field: {value, onChange}}) => (
                        <VmoDatePicker
                          placeholder="Select a date task-datepicker"
                          time={false}
                          dropUp
                          value={value}
                          onChange={value => onChange(value)}
                        />
                      )}
                    />
                    {errors.startDate && <div>{errors.startDate.message}</div>}
                  </VmoFormField>
                </VmoCardContent>
              </VmoCard>
            </>
          )}
        </VmoForm>
      </div>
      <div className="setActionBtn">
        <VmoButton
          basic
          onClick={() => {
            if (editId) {
              navigate(getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.SERVICE_COMPONENTS))
              dispatch({type: CLEAR_SINGLE_COMPO})
            } else {
              navigate(getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.SERVICE_COMPONENTS))
              toggleForm(false)
            }
          }}
          disabled={isLoadingData && rType.includes(UPDATE_SERVICES_COMPO)}
          loading={isLoadingData && rType.includes(UPDATE_SERVICES_COMPO)}
        >
          Cancel
        </VmoButton>
        <LockPermissionTooltip isRoleAccessDenied={!allowManageServiceRole}>
          <VmoButton
            primary
            className={!allowManageServiceRole ? 'disabled-button' : ''}
            {...(allowManageServiceRole && {
              onClick: handleSubmit(submitData),
            })}
            disabled={!isDirty || (isLoadingData && rType.includes(UPDATE_SERVICES_COMPO))}
            loading={isLoadingData && rType.includes(UPDATE_SERVICES_COMPO)}
          >
            {editId ? 'Update' : 'Create'}
          </VmoButton>
        </LockPermissionTooltip>
      </div>
    </>
  )
}
